import * as React from 'react'

import { Button } from '~/client/src/shared/components/shadcn-ui/button'

import './FilterHeader.scss'

interface IFilterHeader {
  clickOnClearAll?: () => void
  clickOnSelectAll: () => void
  className?: string
}

class FilterHeader extends React.Component<IFilterHeader> {
  public render() {
    const { clickOnClearAll, clickOnSelectAll, children, className } =
      this.props

    return (
      <div className={'filter-header ' + (className || '')}>
        {clickOnClearAll && (
          <Button
            variant="primary-outline"
            size="xs"
            className="tw:mr-1"
            onClick={clickOnClearAll}
          >
            Clear All
          </Button>
        )}
        <Button
          variant="primary-outline"
          size="xs"
          className="tw:mr-1"
          onClick={clickOnSelectAll}
        >
          Select All
        </Button>
        {children}
      </div>
    )
  }
}

export default FilterHeader
